import React, { useEffect, useState } from 'react';
import { Box, Alert, Typography, Paper, CircularProgress } from '@mui/material';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import CorporateOwnershipChart from '../components/charts/CorporateOwnershipChart';
import { csAdminApi } from '../services/api';

const OrganizationalStructure = () => {
  const [apiGraph, setApiGraph] = useState(null);
  const [loadError, setLoadError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    csAdminApi
      .getOrgStructure()
      .then((res) => {
        setApiGraph(res.data?.data || { nodes: [], edges: [] });
        setLoadError('');
      })
      .catch((err) => {
        console.error('Org structure API:', err);
        setApiGraph({ nodes: [], edges: [] });
        setLoadError(
          err.response?.data?.error?.message || 'Failed to load organizational structure.'
        );
      })
      .finally(() => setLoading(false));
  }, []);

  const hasLiveData = (apiGraph?.nodes?.length || 0) > 0;
  const showEmptyState = !loading && apiGraph && !hasLiveData;

  return (
    <Box sx={{ height: 'calc(100vh - 64px)', width: '100%', display: 'flex', flexDirection: 'column' }}>
      {hasLiveData && (
        <Alert severity="success" sx={{ m: 1 }}>
          Corporate structure loaded from database ({apiGraph.nodes.length} companies,{' '}
          {apiGraph.edges.length} links).
        </Alert>
      )}

      {loadError && (
        <Alert severity="error" sx={{ m: 1 }}>
          {loadError}
        </Alert>
      )}

      {loading && (
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            gap: 2,
          }}
        >
          <CircularProgress size={40} />
          <Typography variant="body2" color="text.secondary">
            Loading organizational structure…
          </Typography>
        </Box>
      )}

      {showEmptyState && (
        <Paper
          sx={{
            m: 2,
            p: 4,
            textAlign: 'center',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <AccountTreeOutlinedIcon sx={{ fontSize: 56, color: 'text.secondary', mb: 2 }} />
          <Typography variant="h6" gutterBottom>
            No organizational structure to display
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 480 }}>
            No companies are assigned to your account yet. Ask a Group Secretary to assign you to
            one or more companies.
          </Typography>
        </Paper>
      )}

      {!loading && hasLiveData && (
        <Box sx={{ flex: 1, minHeight: 0 }}>
          <CorporateOwnershipChart apiGraph={apiGraph} />
        </Box>
      )}
    </Box>
  );
};

export default OrganizationalStructure;
